'use client';

import { c as _c } from "react/compiler-runtime";
import type { Cruz } from '@cruz-com/lookup';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import _ from 'lodash';
import NextLink from 'next/link';
import { useParams } from 'next/navigation';
import { twMerge } from 'tailwind-merge';
import { userApi } from '@/api';
import { Avatar } from '@/components';
import { LeadTypeEnum, lkpLeadList } from '@/lib';
import { pages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
type Props = {
  initialData: Cruz.User | undefined;
  showContactOwner: boolean;
};
export function NavUserSide(t0) {
  const $ = _c(38);
  const {
    initialData,
    showContactOwner
  } = t0;
  const {
    setMessageToOwnerType
  } = useGlobalStore(_temp);
  const params = useParams();
  const id = initialData?._id || params?.id;
  const t1 = `UserProfile_${id}`;
  let t2;
  if ($[0] !== t1) {
    t2 = [t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== id) {
    t3 = () => userApi.getProfile(id as string);
    $[2] = id;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== initialData || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      staleTime: 1000,
      initialData
    };
    $[4] = initialData;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data
  } = useQuery(t4);
  let t5;
  if ($[8] !== data) {
    t5 = () => {
      const {
        first_name,
        last_name,
        _id,
        location,
        date_create
      } = data || {};
      const {
        city,
        state_abbr
      } = location || {};
      const name = first_name ? `${first_name} ${last_name}` : "";
      return <section className="relative mb-4 flex w-full flex-col items-center text-sm/6 not-italic" aria-label="User Profile Summary"><Avatar className="size-24" photo_url={data?.photo_url} name={name || _id as string} /><div className="mt-3 mb-1 truncate text-lg font-bold">{name}</div><div className="truncate font-light">{city ? `${city}, ${state_abbr}` : "[Unknown Location]"}</div><div className="truncate font-light">Joined {dayjs(date_create).fromNow()}</div></section>;
    };
    $[8] = data;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const renderUserInfo = t5;
  let t6;
  if ($[10] !== data) {
    t6 = t7 => {
      const {
        name: name_0,
        href,
        count
      } = t7;
      if (_.isEmpty(data)) {
        return null;
      }
      if (_.isUndefined(count) || count === 0) {
        return null;
      }
      return <li key={href}><NextLink hrefLang="en" href={href} className="nav-item">{name_0}<span className="sr-only">, count: </span><span className="nav-count">{count}</span></NextLink></li>;
    };
    $[10] = data;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const renderNavItem = t6;
  let t7;
  if ($[12] !== setMessageToOwnerType) {
    t7 = () => {
      const leadTypeList = _.filter(lkpLeadList, _temp2);
      const navStyle = twMerge("nav-item", "h-11");
      return <section className="mt-8" aria-labelledby="contact-owner-heading"><h2 id="contact-owner-heading" className="pt-0! text-lg/7!">Contact Owner<div className="w-7 border-b-4 border-red-800" aria-hidden="true" /></h2><ul className="btn-group" aria-label="Contact Options">{_.map(leadTypeList, t8 => {
            const {
              id: id_0,
              name: name_1
            } = t8;
            return <li key={`lead_${id_0}`}><button type="button" onClick={() => setMessageToOwnerType(id_0)} className={navStyle}>{name_1}</button></li>;
          })}</ul></section>;
    };
    $[12] = setMessageToOwnerType;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const renderContactOwner = t7;
  if (!data) {
    return null;
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t8;
  let t9;
  if ($[14] !== data || $[15] !== renderNavItem || $[16] !== renderUserInfo) {
    const {
      statistic,
      user_base_url
    } = data || {};
    t12 = "User Sidebar Navigation";
    if ($[23] !== renderUserInfo) {
      t13 = renderUserInfo();
      $[23] = renderUserInfo;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    t8 = "btn-group";
    t9 = "User Quick Links";
    t10 = renderNavItem({
      ...pages.userVehicles,
      count: statistic?.vehicle?.active || 0,
      href: `${user_base_url}/vehicles`
    });
    t11 = renderNavItem({
      ...pages.userSpotted,
      count: statistic?.spotted_count || 0,
      href: `${user_base_url}/spotted`
    });
    $[14] = data;
    $[15] = renderNavItem;
    $[16] = renderUserInfo;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t8;
    $[22] = t9;
  } else {
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t13 = $[20];
    t8 = $[21];
    t9 = $[22];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t8 || $[28] !== t9) {
    t14 = <ul className={t8} aria-label={t9}>{t10}{t11}</ul>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t8;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== renderContactOwner || $[31] !== showContactOwner) {
    t15 = showContactOwner && renderContactOwner();
    $[30] = renderContactOwner;
    $[31] = showContactOwner;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t15) {
    t16 = <nav aria-label={t12}>{t13}{t14}{t15}</nav>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}
function _temp2(x) {
  return x.id !== LeadTypeEnum.FinancingInquiry;
}
function _temp(state) {
  return state;
}